/**
 * Пак «По-восточному» — фоны и шаги `state_desktop_*` / `state_mobile_*` в `packs/vostochniy/`.
 */
import vostochniyBgDesktop from '@/assets/img/rice-game/packs/vostochniy/bg-desktop.jpg';
import vostochniyBgDesktop2x from '@/assets/img/rice-game/packs/vostochniy/bg-desktop@2x.jpg';
import vostochniyBgMobile from '@/assets/img/rice-game/packs/vostochniy/bg-mobile.jpg';
import vostochniyBgMobile2x from '@/assets/img/rice-game/packs/vostochniy/bg-mobile@2x.jpg';

import vostochniyStateD01 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_1.png';
import vostochniyStateD02 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_2.png';
import vostochniyStateD03 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_3.png';
import vostochniyStateD04 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_4.png';
import vostochniyStateD05 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_5.png';
import vostochniyStateD06 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_6.png';
import vostochniyStateD07 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_7.png';
import vostochniyStateD08 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_8.png';
import vostochniyStateD09 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_9.png';
import vostochniyStateD10 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_10.png';
import vostochniyStateD11 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_11.png';
import vostochniyStateD12 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_12.png';
import vostochniyStateD13 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_13.png';
import vostochniyStateD14 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_14.png';
import vostochniyStateD15 from '@/assets/img/rice-game/packs/vostochniy/state_desktop_15.png';

import vostochniyStateM01 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_1.png';
import vostochniyStateM02 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_2.png';
import vostochniyStateM03 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_3.png';
import vostochniyStateM04 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_4.png';
import vostochniyStateM05 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_5.png';
import vostochniyStateM06 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_6.png';
import vostochniyStateM07 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_7.png';
import vostochniyStateM08 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_8.png';
import vostochniyStateM09 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_9.png';
import vostochniyStateM10 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_10.png';
import vostochniyStateM11 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_11.png';
import vostochniyStateM12 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_12.png';
import vostochniyStateM13 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_13.png';
import vostochniyStateM14 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_14.png';
import vostochniyStateM15 from '@/assets/img/rice-game/packs/vostochniy/state_mobile_15.png';

export const vostochniyBackgrounds = {
  backgroundDesktop: vostochniyBgDesktop,
  backgroundDesktop2x: vostochniyBgDesktop2x,
  backgroundMobile: vostochniyBgMobile,
  backgroundMobile2x: vostochniyBgMobile2x,
};

export const vostochniyFramesDesktop = [
  vostochniyStateD01,
  vostochniyStateD02,
  vostochniyStateD03,
  vostochniyStateD04,
  vostochniyStateD05,
  vostochniyStateD06,
  vostochniyStateD07,
  vostochniyStateD08,
  vostochniyStateD09,
  vostochniyStateD10,
  vostochniyStateD11,
  vostochniyStateD12,
  vostochniyStateD13,
  vostochniyStateD14,
  vostochniyStateD15,
];

export const vostochniyFramesMobile = [
  vostochniyStateM01,
  vostochniyStateM02,
  vostochniyStateM03,
  vostochniyStateM04,
  vostochniyStateM05,
  vostochniyStateM06,
  vostochniyStateM07,
  vostochniyStateM08,
  vostochniyStateM09,
  vostochniyStateM10,
  vostochniyStateM11,
  vostochniyStateM12,
  vostochniyStateM13,
  vostochniyStateM14,
  vostochniyStateM15,
];
